module.exports = {"542224100":"桑日镇","542224200":"增期乡","542224201":"白堆乡","542224202":"绒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542224.json
// module id = 2749
// module chunks = 0